'use client';
import styled from 'styled-components';

export const BenefitsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${props => props.theme.spacing(5)} 0;
  flex: 0;
`;

export const Benefit = styled.div`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: ${props => props.theme.spacing(2)};
  flex: 1;
`;

export const Text = styled.p`
  ${props => props.theme.fontFamily.condensed}
  margin-left: ${props => props.theme.spacing(4)};
`;
